import { database  } from '../database'

/**
 * Update user data
 *
 * @param {Object} user
 * @param {Object} data
 * @return {*}
 */
export const updateUser = (user, data) => (
    database('user')
        .doc(user.uid)
        .set({
            ...user,
            ...data,
        })
)
